import React, { useEffect } from "react";
import Banner from "./Banner";
import LaunchingSoon from "./LaunchingSoon";
import Services from "./Services";
import Clint from "./Clint";
import Footer from "../../common/Footer";
import HelpSection from "./HelpSection";
import ImageSection from "./ImageSection";
import Header from "../../common/Header";

export const launchingRef = React.createRef();

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <Banner />
      <div ref={launchingRef}>
        <LaunchingSoon />
      </div>
      <Services />
      <Clint />
      <ImageSection />
      <HelpSection />
      <Footer />
    </>
  );
};

export default Home;
